<div class="editor-sidebar-title">
  <h3 style="display:block;margin:1px;" class="file-name">Fields to be used</h3>
  <div>Click to copy to clipboard</div>
</div>
<div class="sidebar-content">
  <mat-list>
    <mat-list-item *ngFor="let item of listData" class="filed-item" (click)="copy(item.value)">
      <div mat-line><strong>{{item.text}}</strong></div>
      <div mat-line> {{item.value}} </div>
    </mat-list-item>
  </mat-list>
</div>
